"use client";

import Image from "next/image";
import { SwiperSlide } from "swiper/react";

import { CtfEntry, TypeImageWithAltTextSkeleton } from "@/clients/contentful";
import { Carousel } from "@/common/components/carousel/carousel";

type ProductImageCarouselProps = {
  assets?: (CtfEntry<TypeImageWithAltTextSkeleton> | undefined)[];
};

export function ProductImageCarousel({ assets, ...previewProps }: ProductImageCarouselProps) {
  return (
    <Carousel
      pagination={{
        clickable: true,
      }}
      className="product-gallery -mx-4 md:-mx-8 lg:mx-0"
      buttonGroupClassName="hidden"
      {...previewProps}
    >
      {assets?.map(
        (asset, index) =>
          asset && (
            <SwiperSlide key={`product-gallery-key-${index}`}>
              <div className="col-span-1 transition duration-150 ease-in">
                <Image
                  priority
                  src={`https:${asset?.fields.image?.fields.file?.url}`}
                  alt={asset.fields.altText || "Product Image"}
                  width={asset.fields.image?.fields.file?.details.image?.width || 618}
                  height={asset.fields.image?.fields.file?.details.image?.height || 476}
                  className="aspect-[3/2] w-full object-cover"
                  sizes="(max-width: 1023px) 100vw, 50vw"
                />
              </div>
            </SwiperSlide>
          ),
      )}
    </Carousel>
  );
}

export function ProductImageCarouselSkeleton() {
  return (
    <div className="product-gallery -mx-4 md:-mx-8 lg:mx-0">
      <div className="test-carousal"></div>
      <div className="flex space-x-4 overflow-hidden">
        <div className="bg-grey-30 col-span-1 aspect-[3/2] w-full animate-pulse transition duration-150 ease-in hover:opacity-90" />
      </div>
    </div>
  );
}
